/* Sheets-style cell comment editor, anchored at the click coordinates. */
import { MessageSquare, Trash2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { fmtTs } from './attendanceUtils';

export const RemarkPopover = ({ popup, canEdit, saving, onChangeText, onSave, onClose }) => {
  if (!popup) return null;
  return (
    <>
      <div className="fixed inset-0 z-40" onClick={onClose} />
      <div
        className="fixed z-50 w-[300px] rounded-lg border bg-card shadow-xl p-3 space-y-2"
        style={{ left: popup.x, top: popup.y }}
        data-testid="attendance-remark-popup"
      >
        <div className="flex items-center gap-2 text-sm font-medium">
          <MessageSquare className="w-4 h-4 text-amber-600" />
          <span className="truncate">{popup.traineeName}</span>
          <span className="text-xs text-muted-foreground ml-auto shrink-0">{popup.date}</span>
        </div>
        {canEdit ? (
          <textarea
            autoFocus
            rows={3}
            maxLength={1000}
            value={popup.text}
            onChange={(e) => onChangeText(e.target.value)}
            placeholder="e.g. Sick leave — doctor's appointment"
            className="w-full rounded-md border bg-background p-2 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-amber-500/40"
            data-testid="attendance-remark-input"
          />
        ) : (
          <p className="text-sm rounded-md bg-muted/40 p-2 whitespace-pre-wrap" data-testid="attendance-remark-readonly">
            {popup.remark?.text || '—'}
          </p>
        )}
        {popup.remark && (
          <div className="text-[11px] text-muted-foreground space-y-0.5" data-testid="attendance-remark-meta">
            <div>Added by <span className="font-medium text-foreground">{popup.remark.created_by_name || 'Unknown'}</span> · {fmtTs(popup.remark.created_at)}</div>
            {popup.remark.updated_at && (
              <div>Edited by <span className="font-medium text-foreground">{popup.remark.updated_by_name || 'Unknown'}</span> · {fmtTs(popup.remark.updated_at)}</div>
            )}
          </div>
        )}
        {canEdit && (
          <div className="flex items-center gap-2 pt-1">
            {popup.remark && (
              <Button size="sm" variant="ghost" className="text-rose-600 hover:text-rose-700 px-2"
                      disabled={saving} onClick={() => onSave('')}
                      data-testid="attendance-remark-delete-btn">
                <Trash2 className="w-3.5 h-3.5" />
              </Button>
            )}
            <Button size="sm" variant="outline" className="ml-auto" onClick={onClose}
                    data-testid="attendance-remark-cancel-btn">
              Cancel
            </Button>
            <Button size="sm" disabled={saving || !popup.text.trim()}
                    onClick={() => onSave(popup.text)}
                    data-testid="attendance-remark-save-btn">
              Save
            </Button>
          </div>
        )}
      </div>
    </>
  );
};
